export const RATE_UPDATE_SAGA = "RATE_UPDATE_SAGA";
export const RATE_UPDATE_SUCCESS = "RATE_UPDATE_SUCCESS";
export const RATE_UPDATE_FAILURE = "RATE_UPDATE_FAILURE";
